module.exports = __webpack_public_path__ + "img/Spaceship.3b77f02e.svg";